import { useEffect } from "react";
import { Control, Controller, RegisterOptions } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { fetchOrganizationSelector } from "../../../redux/actions/catalog/catalog";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { Selector } from "../selector";
import { IonItem } from "@ionic/react";

interface IOrganizationSelector {
    name: string;
    onChange: (ev: any) => any;
    selectedKey: string;
    control: Control<any>;
    rules?: RegisterOptions;
}

export const OrganizationSelector: React.FC<IOrganizationSelector> = ({ name, onChange, selectedKey, control, rules }) => {
    const { t } = useTranslation("common");
    const { data, loading } = useAppSelector((state) => state.catalog.organizations);
    const dispatch = useAppDispatch();
    const mapOptions = () => {
        return data.map((item, index) => {
            return {
                description: item.name,
                id: index,
                key: item.id,
            };
        });
    };

    useEffect(() => {
        !data.length && dispatch(fetchOrganizationSelector());
    }, []);

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={selectedKey}
            render={({ field: { value }, fieldState: { error } }) => (
                <Selector
                    label={t("PAGE.LOGIN.ORGANIZATION")}
                    options={mapOptions()}
                    onChange={onChange}
                    selectedKey={selectedKey || value}
                    disabled={loading}
                />
            )}
        />
    );
};
